import { useEffect, useState } from 'react';

import errorHandler from '@server/logger/errorHandler';

import {
  type DocumentData,
  type DocumentReference,
  type FirestoreError,
  getDoc,
  onSnapshot,
} from 'firebase/firestore';

const useDocumentDataFetch = <T extends DocumentData>(
  docRef: DocumentReference<T>,
  realtimeUpdates: boolean = false,
) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<FirestoreError | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getDocument = async () => {
      if (realtimeUpdates) {
        const unsubscribe = onSnapshot(
          docRef,
          docSnap => {
            if (docSnap.exists()) {
              setData({ ...docSnap.data(), id: docSnap.id });
            }
          },
          error => {
            setError(error);
          },
        );
        setLoading(false);
        return () => {
          console.log('unsubscribing...');
          unsubscribe();
        };
      } else {
        try {
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setData({ ...docSnap.data(), id: docSnap.id });
          }
        } catch (error: any) {
          setError(error);
          errorHandler({ error });
        } finally {
          setLoading(false);
        }
      }
    };
    getDocument();
  }, []);

  return { data, error, loading };
};

export default useDocumentDataFetch;
